import useUser from 'utils/useUser';
import { hasCombinedModuleAccess } from 'infrastructure/functions';
import { RoleGroups } from 'infrastructure/consts';

import type { UserType } from 'infrastructure/enums';

export const useCheckRoleAccess = () => {
  const { roleNames, userType } = useUser();

  const isReadOnlyRole = !hasCombinedModuleAccess(
    roleNames,
    RoleGroups.ReadOnlyDenyRolesMap,
    userType as UserType,
  );

  return {
    isReadOnlyRole,
  };
};
